import styled from "styled-components";

export const Wrapper = styled.div`
    padding: ${({ theme }) => `${theme.spacing.small} ${theme.spacing.medium} ${theme.spacing.xSmall}`};
`;
